import apiClient from 'hub-http/clients/apiClient';
export const fetchCommerceAnalyticsData = () => apiClient.get('commerce/analytics/v1/home');